import Vue from 'vue'
import {
  VApp,
  VBtn,
  VIcon,
  VDivider,
  VStepper,
  VSelect,
  Vuetify,
  VChip,
  VDialog,
  VProgressLinear
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VBtn,
    VIcon,
    VSelect,
    VStepper,
    VDivider,
    VProgressLinear,
    VChip,
    VDialog,
  },
  theme: {
    primary: '#29507d',
    secondary: '#5fa8ff',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
})
